import React from 'react'
import { Col, RadioButton, Radio, Spin } from 'core/components/ui'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { InputWrapper, InterTitle } from '../../styled'

const FormItem = ({ setTradeIn, tradeIn, loading, paramsFinancingQuestion }) => {
  const { futherInformations } = tradeIn

  const handleChange = value => {
    const extendedFutherInformations = {
      ...futherInformations,
      funding: value
    }
    setTradeIn({
      ...tradeIn,
      futherInformations: extendedFutherInformations
    })
  }

  return (
    <Col xs={{ span: 24 }} lg={{ span: 12 }}>
      <InterTitle>
        <FormattedMessage id="tradeIn-futher-informations-question-1-label" />
      </InterTitle>
      <InputWrapper type="flex">
        <Col span={24}>
          {loading ? (
            <Spin />
          ) : (
            <Radio.Group
              buttonStyle="solid"
              value={futherInformations && futherInformations.funding}
              onChange={e => handleChange(e.target.value)}
            >
              {paramsFinancingQuestion.map(item => (
                <RadioButton value={item.key} key={item.key}>
                  {item.value}
                </RadioButton>
              ))}
            </Radio.Group>
          )}
        </Col>
      </InputWrapper>
    </Col>
  )
}
FormItem.defaultProps = {
  loading: true,
  paramsFinancingQuestion: []
}

FormItem.propTypes = {
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: PropTypes.any.isRequired,
  loading: PropTypes.any,
  paramsFinancingQuestion: PropTypes.array
}

export default { FormItem }
